/* eslint-disable react/no-danger */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import { getSolutionContactDetails } from "../../utils/data/getContactDetails";

// Components
import ContactMethods from "../contact-details-box/contact-methods/ContactMethods";

// Styles
import styles from "./ContactUsRepairUpdateElectricalItem.module.scss";

function ContactUsRepairUpdateElectricalItem({ solution: { id, title, fields, hierarchyPosition }, className }) {
  const locationOnPage = hierarchyPosition.join(" | ");
  const [contactDetails, setContactDetails] = useState(null);

  useEffect(() => {
    getSolutionContactDetails(locationOnPage)
      .then(res => setContactDetails(res))
      .catch(() => setContactDetails(null));
  }, []);

  return (
    <article className={classnames(styles.repairUpdateElectricalItem, className)} data-solution-id={id}>
      <h2 className={styles.repairUpdateElectricalItem__top}>Did you know...</h2>

      <div className={styles.repairUpdateElectricalItem__inner} data-test="solution-inner">
        {title && (
          <h2 data-test="solution-name" className={styles.repairUpdateElectricalItem__title}>
            {title}
          </h2>
        )}

        <div className={styles["repairUpdateElectricalItem__contact-details"]}>
          {!contactDetails && <LoadingSpinner />}
          {contactDetails && (
            <ContactMethods
              fields={fields.filter(({ name }) => ["phone", "chat"].includes(name))}
              solutionId={id}
              location={locationOnPage}
              contactDetails={contactDetails}
            />
          )}
        </div>
      </div>
    </article>
  );
}

ContactUsRepairUpdateElectricalItem.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    buttonType: PropTypes.string,
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
  contactMethods: PropTypes.shape({
    emailUs: PropTypes.arrayOf(PropTypes.string),
    liveChat: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string, pct: PropTypes.number })]),
    ),
    partnersLiveChat: PropTypes.arrayOf(PropTypes.string),
  }),
};

ContactUsRepairUpdateElectricalItem.defaultProps = {
  className: undefined,
  contactMethods: {},
};

export default ContactUsRepairUpdateElectricalItem;
